import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ClipboardChecklist from './icon-clipboard-checklist.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ClipboardChecklist {...validProps} fill={validProps.fill || validProps.color} />;
}
SvgComponent.iconName = 'clipboard-checklist';

/**
 * @deprecated This is a legacy icon
 */
export const ClipboardChecklistIcon = svgIconWrapper(SvgComponent);
